import { z } from 'zod';

// One row per column of a transform's output. Matches the 10-column schema
// the data-warehouse pipeline emits in the sibling Snowflake table. Column
// names are lowercased by the Dagster Python executor when streaming to CSV
// (see dagster_transform_executor.py). `column_name` is the join key
// against DatabaseSchemaColumnBase.headerValue on the frontend.
//
// `enum_values` is a JSON-encoded array string (e.g. '["Asian","White"]').
// `metadata` is a JSON-encoded object string; known keys include
// `display_name`, `user_facing`, `best`, `computation_method`, `enum_values`,
// `semantic_type`, `data_type`, and optionally `example` / `examples`.
export const TransformDictionaryRow = z.object({
  column_name: z.string(),
  description: z.string().optional(),
  data_type: z.string().optional(),
  semantic_type: z.string().optional(),
  enum_values: z.string().optional(),
  computation_method: z.string().optional(),
  metadata: z.string().optional(),
  source_generator: z.string().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});

export type TransformDictionaryRow = z.infer<typeof TransformDictionaryRow>;
